import type { IdDocumentType } from './person';

export const idDocumentValidators: Record<
  IdDocumentType,
  { pattern: { value: RegExp; message: string } }
> = {
  UMID: {
    pattern: {
      value: /^\d{4}-\d{7}-\d$/,
      message: 'Enter the full document number',
    },
  },
  PHIL_ID: {
    pattern: {
      value: /^\d{4}-\d{4}-\d{4}-\d{4}$/,
      message: 'Enter the full document number',
    },
  },
  PHIL_SYS_ID: {
    pattern: {
      value: /^\d{4}-\d{4}-\d{4}-\d{4}$/,
      message: 'Enter the full document number',
    },
  },
  DIGITAL_NATIONAL_PHIL_ID: {
    pattern: {
      value: /^\d{4}-\d{4}-\d{4}-\d{4}$/,
      message: 'Enter the full document number',
    },
  },
  E_PHIL_ID: {
    pattern: {
      value: /^\d{4}-\d{4}-\d{4}-\d{4}$/,
      message: 'Enter the full document number',
    },
  },
  PRC: {
    pattern: {
      value: /^\d{7}$/,
      message: 'Enter the full document number',
    },
  },
  DRIVING_LICENSE: {
    pattern: {
      value: /^[A-Z]\d{2}-\d{2}-\d{6}$/,
      message: 'Enter the full document number',
    },
  },
  PASSPORT: {
    pattern: {
      value: /^[A-Z]\d{7}[A-Z]$/,
      message: 'Enter the full document number',
    },
  },
  SSS: {
    pattern: {
      value: /^\d{2}-\d{7}-\d$/,
      message: 'Enter the full document number',
    },
  },
  POSTAL_ID: {
    pattern: {
      value: /^[\dA-ZÑ]{12}$/,
      message: 'Enter the full document number',
    },
  },
};
